import {useSnackbar} from "notistack";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
} from "@mui/material";
import {useEffect, useState} from "react";
import * as React from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import * as XLSX from 'xlsx';
import sendRequest from "../services/sendRequest";
import MoonLoader from "react-spinners/MoonLoader";
import DownloadIcon from "@mui/icons-material/Download"; // Import
import {IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const UnknownDealUpload = ({open, close, listOfClients, selected, setRefresh}) => {

  const {enqueueSnackbar, closeSnackbar} = useSnackbar()
  // const [items, setItems] = useState([]);
  // const [formData, setFormData] = useState({});
  // const [fullWidth, setFullWidth] = React.useState(true);
  // const [maxWidth, setMaxWidth] = React.useState('sm');
  let [loading, setLoading] = useState(false);
  let [color] = useState("#000000");
  const page = "deals";
  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
  };
  const handleClose = () => {
    close();
  };

  useEffect(() => {
  });

  // handle file upload
  const handleFileUpload = e => {
    const expectedColumns = sample_CSV_data[0].join(", ");

    let showWarning = true;
    let isValidColumns = true;
    let inValideCustomIdStem = true;
    let inValidReportType = true;
    let inValidType = true;
    let inValidClient = true;
    let inValidClientShare = true;
    let inValidEmail = true;
    let inValidCurrency = true;
    let inValidReportCurrency = true;
    let inValidStatus = true;
    let inValidCanSend = true;
    let inValidPermittedDeduction = true;
    let inValidMin_Guarantee = true;
    let invalidRowIndex = 0;
    let client_name = ""
    setLoading(true)
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = async (evt) => {
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, {type: 'binary'});
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const Papa = require('papaparse');
      const fileData = XLSX.utils.sheet_to_csv(ws, {header: 1});

      // Parse the CSV data
      const parsedData = Papa.parse(fileData, {
        header: false, // Set to true if the first row contains headers
      });

      // Initialize an array to hold column-wise data
      let columns = [];
      const items = [];

      // Iterate through each row
      parsedData.data.forEach((row, rowIndex) => {
        // Iterate through each cell and organize them into columns
        //row = row.filter(element => element !== "");
        // console.log('row',row.length)
        // console.log('sample_CSV_data',sample_CSV_data[0].length)
        if (row.length !== sample_CSV_data[0].length) {
          isValidColumns = false;
          showWarning = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        }
        row.forEach((cell, colIndex) => {
          // Initialize the column array if it doesn't exist
          if (!columns[colIndex]) {
            columns[colIndex] = [];
          }
          // Add the cell to the appropriate column
          columns[colIndex][rowIndex] = cell;
        });

        // Below code is check custom_id_stem contains exactly (3) three Characters it may Contans uppercase letters and numbers.
        const capitalLetterOrDigitRegex = /^[A-Z0-9]{3}$/;
        if (!capitalLetterOrDigitRegex.test(row[0])) {
          showWarning = false;
          inValideCustomIdStem = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        }

        // if (row[2] == "" || row[2] == null) {
        //   row[10] = "FALSE"
        // }
        if (row[2] !== "" && row[2] != null) {
          if (!row[2].includes('@')) {
            showWarning = false;
            inValidEmail = false;
            invalidRowIndex = rowIndex;
            return; // Break the loop
          }
        }

        // Below code is check report_type is valid or not.
        if (row[3] !== "Full With Geo" && row[3] !== "Basic" && row[3] !== "Full Non Geo") {
          showWarning = false;
          inValidReportType = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        }

        // Below code is check Client Share is valid or not.
        if (parseFloat(row[4]) < 0 || parseFloat(row[4]) > 100) {
          showWarning = false;
          inValidClientShare = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        }

        // Below code is check type is valid or not.
        if (row[5] !== "de" && row[5] !== "all") {
          showWarning = false;
          inValidType = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        }
        console.log('listOfClients', listOfClients)
        // Below code is check Client is valid or not.
        if (row[6] !== "" && row[6] != null) {
          if (!listOfClients.includes(row[6].trim())) {
            showWarning = false;
            inValidClient = false;
            invalidRowIndex = rowIndex;
            client_name = row[6];
            return; // Break the loop
          }
        }

        // Below code is check Currency is valid or not.
        if (row[7] !== "EUR" && row[7] !== "GBP" && row[7] !== "USD") {
          showWarning = false;
          inValidCurrency = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        } else {
          switch (row[7]) {
            case "EUR":
              row[7] = 9;
              break;
            case "GBP":
              row[7] = 1;
              break;
            case "USD":
              row[7] = 2;
              break;
            default:
              break;
          }
        }

        // Below code is check Report Currency is valid or not.
        if (row[8] !== "EUR" && row[8] !== "GBP" && row[8] !== "USD") {
          showWarning = false;
          inValidReportCurrency = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        } else {
          switch (row[8]) {
            case "EUR":
              row[8] = 9;
              break;
            case "GBP":
              row[8] = 1;
              break;
            case "USD":
              row[8] = 2;
              break;
            default:
              break;
          }
        }

        // Below code is check Status is valid or not.
        if (row[9] !== "verified" && row[9] !== "unverified") {
          showWarning = false;
          inValidStatus = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        }

        // Below code is check Can Send is valid or not.
        if (row[10] !== "TRUE" && row[10] !== "FALSE") {
          showWarning = false;
          inValidCanSend = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        }

        // Below code is check Permitted Deduction is valid or not.
        if (parseFloat(row[11]) < 0 || parseFloat(row[11]) > 100) {
          showWarning = false;
          inValidPermittedDeduction = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        }

        // Below code checks if min guarantee is valid or not.
        if (!/^\d{1,10}(\.\d{2})?$/.test(row[12])) {
          showWarning = false;
          inValidMin_Guarantee = false;
          invalidRowIndex = rowIndex;
          return; // Break the loop
        }

        // Create an object for each row
        const newObject = {
          custom_id_stem: row[0],
          name: row[1],
          report_emails: row[2],
          report_type: row[3],
          client_rev_share: row[4],
          type: row[5],
          client: row[6],
          currency: row[7],
          report_currency: row[8],
          status: row[9],
          can_send: row[10],
          permitted_deduction: row[11],
          min_guarantee: row[12],
        };
        items.push(newObject);
      });
      console.log(items);
      if (showWarning) {
        try {
          const response = await sendRequest({
            requestType: "post",
            endpoint: `${page}/custom_bulk_create/`,
            requestData: {
              items: items,
              email: localStorage.getItem('username'),
            },
          });

          if (response.status === 200) {
            // setItems([]);
            if (response && response.data && response.data.deal_list) {
              localStorage.setItem('bulk_deals', JSON.stringify(response.data.deal_list));
            }
            if (response.data.deal_not_available === true) {
              handleAllTypesOfMessages(response.data.message, 'warning');
            } else {
              handleAllTypesOfMessages(response.data.message, 'success');
            }
            handleClose();
          } else {
            handleAllTypesOfMessages('There is an Error with the file, Please Check the .csv file and Reupload it!', 'error');
          }

        } catch (error) {
          console.error("An error occurred:", error);
          handleAllTypesOfMessages('There is an Error with the file, Please Check the .csv file and Reupload it!', 'error');
        } finally {
          // setItems([]);
          setLoading(false);
          handleClose();
        }
      } else {
        // setItems([]);
        if (!isValidColumns) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that the file contains only these 13 Columns [${expectedColumns}] in the specified order and does not include any headers`, 'warning');
        } else if (!inValideCustomIdStem) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that the Custom ID Stem for all records contains exactly (3) three characters, which may include uppercase letters and numbers.`, 'warning');
        } else if (!inValidReportType) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that the Report Type for all records is either "Full With Geo," "Basic," or "Full Non Geo`, 'warning');
        } else if (!inValidType) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that the Type for all records is either "de" or "all`, 'warning');
        } else if (!inValidClientShare) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that the Client Share for all records is between 0 and 100, inclusive`, 'warning');
        } else if (!inValidEmail) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Email addresses are required, and all records must have a valid email address.`, 'warning');
        } else if (!inValidClient) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Invalid client: " ${client_name}" is not listed in the Client section. Please enter a valid client name.`, 'warning');
        } else if (!inValidCurrency) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that the Currency for all records is either "EUR" or "GBP" or "USD" `, 'warning');
        } else if (!inValidReportCurrency) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that the Report Currency for all records is either "EUR" or "GBP" or "USD" `, 'warning');
        } else if (!inValidStatus) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that the Status for all records is either "verified" or "unverified" `, 'warning');
        } else if (!inValidCanSend) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that the CanSend for all records is either true or false `, 'warning');
        } else if (!inValidPermittedDeduction) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that the Permitted Deduction for all records is between 0 and 100, inclusive `, 'warning');
        } else if (!inValidMin_Guarantee) {
          handleAllTypesOfMessages(`Row ${invalidRowIndex + 1} : Ensure that there are no more than 10 digits before the decimal point. `, 'warning');
        }
        setLoading(false)
        handleClose();
      }
    };
    reader.readAsBinaryString(file);
  }

  //handleAllTypesOfMessages
  // const handleAllTypesOfMessages = (message, type) => {
  //   enqueueSnackbar(message, {
  //     variant: type,
  //   });
  // };

  //handleAllTypesOfMessages
  const handleAllTypesOfMessages = (message, type) => {
    const action = (key) => (
      <IconButton
        aria-label="close"
        color="inherit"
        onClick={() => closeSnackbar(key)}
      >
        <CloseIcon/>
      </IconButton>
    );

    enqueueSnackbar(message, {
      variant: type,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      persist: true, // <- keeps the snackbar visible until manually closed
      // autoHideDuration: 20000,
      action
    });
  };
  const sample_CSV_data = [
    [
      "Custom ID Stem",
      "Deal Name",
      "Report Email Addresses",
      "Report Type",
      "Client Share",
      "Type",
      "Client",
      "Currency",
      "Report Currency",
      "Status",
      "CanSend",
      "Permitted Deduction",
      "Min Guarantee",
    ],
    [
      "ABC",
      "Deal",
      "abc@gmail.com",
      "Full With Geo",
      "50.6",
      "de",
      "AAA",
      "USD",
      "USD",
      "verified",
      "TRUE",
      "99.5",
      "7829440565",
    ],
    [
      "DEF",
      "Deal",
      "def@gmail.com",
      "Full With Geo",
      "50.6",
      "de",
      "BBB",
      "USD",
      "USD",
      "verified",
      "FALSE",
      "99.5",
      "7829440565",
    ],
  ];

  // const handleDownload = () => {
  //   // Define the data
  //
  //
  //   // Create a workbook and worksheet
  //   const worksheet = XLSX.utils.aoa_to_sheet(sample_CSV_data);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Deals");
  //
  //   // Adjust column widths
  //   const columnWidths = sample_CSV_data[0].map((header) => ({wch: header.length + 5}));
  //   worksheet["!cols"] = columnWidths;
  //
  //   // Write the workbook to a file
  //   XLSX.writeFile(workbook, "Deal_Bulk.xlsx");
  // };

  const handleDownload = () => {
    const worksheet = XLSX.utils.aoa_to_sheet(sample_CSV_data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Deals");

    XLSX.writeFile(workbook, "Deal_Bulk.csv");
  };

  const cellStyle = {
    border: '1px solid #ccc',
    padding: '8px',
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        close();
      }}
    >
      <DialogContent>
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          open={open}
          onClose={handleClose}
        >
          <MoonLoader
            color={color}
            loading={loading}
            cssOverride={override}
            size={40}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
          <DialogTitle sx={{textAlign: 'center'}}>Upload CSV</DialogTitle>
          <DialogContent sx={{marginBottom: 2}}>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              gap: '8px', fontWeight: 600, width: '100%',
            }}>
              <h3>Upload a .CSV file to Create the new Deals!</h3>
              <Button
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon/>}
                onClick={handleDownload}
              >
                Download sample CSV
              </Button>
            </div>
            <DialogContentText sx={{textAlign: 'left', whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
              <b>The .CSV file with no headers should contain the following columns in the specified order:<br/>
                {/*1) Custom ID Stem <br/>*/}
                {/*2) Deal Name <br/>*/}
                {/*3) Report Email Addresses <br/>*/}
                {/*4) Report Type <br/>*/}
                {/*5) Client Share <br/>*/}
                {/*6) Type <br/>*/}
                {/*7) Client <br/>*/}
                {/*8) Currency <br/>*/}
                {/*9) Report Currency <br/>*/}
                {/*10) Status <br/>*/}
                {/*11) CanSend br/>*/}
                {/*12) Permitted Deduction <br/>*/}
                {/*13) Min Guarantee */}
              </b>
              <table style={{
                width: '100%', borderCollapse: 'collapse', fontSize: '14px',
              }}>
                <thead>
                <tr>
                  {sample_CSV_data[0].map((header) => (
                    <th
                      key={header}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        textAlign: 'left',
                        backgroundColor: '#f5f5f5',
                      }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
                </thead>

                <tbody>
                {sample_CSV_data.slice(1).map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                      <td key={cellIndex} style={cellStyle}>
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
                </tbody>
              </table>
            </DialogContentText>

            <DialogContentText
              sx={{textAlign: 'center', whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
              <b>A download option is available above to access a sample template for reference before uploading your
                file. The template file contains the headers as well, but please ensure to remove the headers before
                uploading.</b>
            </DialogContentText>
            <Box
              noValidate
              component="form"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                m: 'auto',
                width: 'fit-content',
              }}
            >
              <FormControl sx={{mt: 2, minWidth: 120}}>
                <input type="file" accept=".csv,.xlsx,.xls" onChange={handleFileUpload}/>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </DialogContent>
    </Dialog>
  );
};

export default UnknownDealUpload;
